<div class="header">
  <spb-logo title="Skapa sparkonto"></spb-logo>
  <div [style.flex-grow]="1"></div>
  <spb-toggle-button/>
  @if (service.currentUser()?.name) {
    <span>{{ service.currentUser()!.name }}</span>
    <button
      [style.margin-right.px]="50"
      [matMenuTriggerFor]="menu" mat-icon-button>
      <mat-icon>menu</mat-icon>
    </button>
  }
</div>

<mat-menu #menu="matMenu">
  <button (click)="service.reset()" mat-menu-item>Logga ut</button>
</mat-menu>